import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import SearchIcon from "../../../components/kit/Icons/SearchIcon";
import Logotype from "../../../components/kit/Logo/Logotype";
import * as doctorActions from "../../../redux/actions/doctorActions";
import * as specialityActions from "../../../redux/actions/specialityActions";
import DoctorTab from "../../DoctorTab";
import DoctorList from "../doctors/DoctorList";
import SimpleAlert from "./Alert/SimpleAlert";
import LoadingComponent from "./LoadingComponent/LoadingComponent";
import { logoWidth } from "../../../constants.json";
import GeneralButton from "../../../components/kit/GeneralButton/GeneralButton";
import getExludedService from "../../../api/excludedServiceApi";

class ChooseMaster extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      inputSearch: "",
      isLoading: true,
      filteredDoctors: [],
    };
  }

  async componentDidMount() {
    try {
      await this.props.loadDoctors();
      const response = await getExludedService();
      const excludedData = response || [];
      const excludedDoctorsForService = excludedData.filter(
        (item) => Number(item.IdService) === Number(this.props.selectedService),
      );
      const excludedDoctorIds = excludedDoctorsForService.map((item) =>
        Number(item.IdDoctor),
      );
      const filteredDoctorsBySpeciality = this.props.doctors.filter(
        (doctor) =>
          doctor.IdSpeciality === this.props.selectedSpecialityId ||
          doctor.AddSpecialities.some(
            (AddSpeciality) =>
              AddSpeciality.Id === this.props.selectedSpecialityId,
          ),
      );
      const filteredDoctors = filteredDoctorsBySpeciality.filter(
        (doctor) => !excludedDoctorIds.includes(doctor.Id),
      );
      this.setState({
        filteredDoctors,
        isLoading: false,
        errorMessage: "",
      });
    } catch (error) {
      console.log(error);
      this.setState({
        errorMessage: "Ошибка загрузки врачей: " + error,
        isLoading: false,
      });
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      errorMessage: props.errorMessage,
    });
  }

  render() {
    return (
      <>
        {this.state.errorMessage && (
          <SimpleAlert
            severity="error"
            errorMessage={this.state.errorMessage}
          />
        )}

        <div className="choose-master-root">
          <div className="choose-master-root__title">
            <p className="title">
              Выберите врача для записи
              <p>
                Если Вас не устраивает время онлайн записи, позвоните нам - мы
                обязательно Вам поможем
              </p>
            </p>

            <Logotype className={"choose-master-root-logo"} width={logoWidth} />
          </div>

          <label className="choose-master-root__search">
            <SearchIcon
              width="15"
              height="15"
              className={"choose-master-root__search-icon"}
            />

            <input
              onChange={(e) => {
                this.setState({
                  inputSearch: e.target.value.toLocaleLowerCase(),
                });
              }}
              type="text"
              placeholder="Поиск по ФИО"
            />
          </label>

          {this.state.isLoading ? (
            <LoadingComponent />
          ) : (
            <DoctorList
              doctors={this.state.filteredDoctors}
              onSelectMaster={this.props.onSelectMaster}
              inputSearch={this.state.inputSearch}
              selectedSpecialityId={this.props.selectedSpecialityId}
            />
          )}

          <div className="d-flex">
            <GeneralButton title="Назад" onClick={this.props.handleClickPrev} />
          </div>
        </div>
      </>
    );
  }
}

ChooseMaster.propTypes = {
  specialities: PropTypes.array.isRequired,
  doctors: PropTypes.array.isRequired,
  loadDoctors: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    specialities: state.specialities.map((speciality) => {
      return {
        ...speciality,

        doctors: state.doctors.filter((doctor) => {
          let allSpecialities = [doctor.SpecialityName].concat(
            doctor.AddSpecialities,
          );

          return allSpecialities.find((el) => el === speciality.Name);
        }),
      };
    }),

    doctors: state.doctors.map((doctor) => {
      return {
        ...doctor,

        specialities: state.specialities.filter(
          (speciality) => speciality.Id === doctor.IdSpeciality,
        ),
      };
    }),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadDoctors: () => dispatch(doctorActions.loadDoctors()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChooseMaster);
